(() => {
  const root = document.querySelector('[data-mck-root]');
  if (!root) return;

  const featureData = {
    edge: { number: '01 / EDGE', title: 'Finished at fifteen degrees.', body: 'A hand-finished three-stage edge gives the broad chef’s blade a precise starting point for slicing, chopping, dicing, and mincing.', spec: '15° · Hand-finished three-stage edge' },
    steel: { number: '02 / STEEL', title: 'German steel, made to work.', body: 'Thyssen-Krupp 1.4116 stainless steel balances edge performance with the corrosion resistance an everyday kitchen knife needs.', spec: '1.4116 · Stainless · 57 HRC' },
    grind: { number: '03 / GEOMETRY', title: 'Thin where movement matters.', body: 'The flat grind and 2.5 millimeter spine support clean, controlled cuts without turning the knife into a fragile showpiece.', spec: 'Flat grind · 2.5 mm spine' },
    handle: { number: '04 / HANDLE', title: 'The blue is more than color.', body: 'The layered Indigo Evergreen handle gives the knife its visual signature while its shaped profile settles naturally into a working grip.', spec: 'Indigo Evergreen · Three fasteners' },
    balance: { number: '05 / CONTROL', title: 'Designed for either hand.', body: 'Ambidextrous geometry and an open heel support a range of grips, from close pinch control to longer rocking cuts.', spec: 'Ambidextrous · 8.03 in blade' }
  };

  const panel = root.querySelector('[data-mck-feature-panel]');
  root.querySelectorAll('[data-feature]').forEach((button) => {
    button.addEventListener('click', () => {
      const feature = featureData[button.dataset.feature];
      if (!feature || !panel) return;
      root.querySelectorAll('[data-feature]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
      panel.querySelector('[data-feature-number]').textContent = feature.number;
      panel.querySelector('[data-feature-title]').textContent = feature.title;
      panel.querySelector('[data-feature-body]').textContent = feature.body;
      panel.querySelector('[data-feature-spec]').textContent = feature.spec;
    });
  });

  const sticky = root.querySelector('[data-mck-sticky]');
  const hero = root.querySelector('[data-mck-hero]');
  if (sticky && hero) {
    const mobilePurchase = window.matchMedia('(max-width: 920px)');
    let heroIsVisible = true;
    const updateSticky = () => sticky.classList.toggle('is-visible', mobilePurchase.matches || !heroIsVisible);
    const observer = new IntersectionObserver(([entry]) => {
      heroIsVisible = entry.isIntersecting;
      updateSticky();
    }, { threshold: .08 });
    mobilePurchase.addEventListener('change', updateSticky);
    updateSticky();
    observer.observe(hero);
  }

  root.querySelectorAll('[data-mck-add]').forEach((button) => {
    button.addEventListener('click', async () => {
      const variantId = root.dataset.variantId;
      const status = root.querySelector('[data-mck-status]');
      if (!variantId || root.dataset.preview === 'true') {
        window.location.href = 'https://rarely.co/products/custom-8-inch-chef-s-knife';
        return;
      }
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
        if (!response.ok) throw new Error('Unable to add');
        button.textContent = 'Added';
        if (status) status.textContent = 'Added to your cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        button.textContent = 'Try again';
        if (status) status.textContent = 'We could not add the knife. Please try again.';
      } finally {
        window.setTimeout(() => { button.disabled = false; if (button.textContent !== 'Try again') button.textContent = 'Add to cart'; }, 1800);
      }
    });
  });
})();
